import type { ReactElement } from 'react';

export type ComfortGlyphKind = 'lock' | 'shield' | 'spark' | 'circle' | 'clock' | 'lantern';

const GLYPHS: Record<ComfortGlyphKind, (props: { title: string }) => ReactElement> = {
  lock: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <path
        d="M7 11V8a5 5 0 0 1 10 0v3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12" cy="16" r="1.25" fill="currentColor" />
    </svg>
  ),
  circle: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <circle cx="12" cy="12" r="7.5" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12" cy="10" r="2" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8.5 15.5c1.2-1.4 2.2-2 3.5-2s2.3.6 3.5 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  clock: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.75" />
      <path d="M12 8v4.5l3 2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  ),
  lantern: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <path d="M12 3v2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path
        d="M8 7h8l-1 10H9L8 7Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M10 21h4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path
        d="M9 12h6"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  ),
  shield: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <path
        d="M12 3 5 6v6c0 4.5 3 8 7 9 4-1 7-4.5 7-9V6l-7-3Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="m9 12 2 2 4-5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  spark: ({ title }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden role="img">
      <title>{title}</title>
      <path
        d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="12" r="2.5" fill="currentColor" opacity="0.85" />
    </svg>
  ),
};

export function ComfortGlyph({ kind, label }: { kind: ComfortGlyphKind; label: string }) {
  const Cmp = GLYPHS[kind];
  return <Cmp title={label} />;
}
